<script setup>
import { ref } from "vue";
import { Dialog, DialogScrollContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";

const props = defineProps({
  registration: {
    type: Object,
    required: true,
    default: {}
  },
  terms: {
    type:String,
    default: ''
  },
  validateUrl: {
    type: String,
    required: true,
  },
});

const showModal = ref(false);

const openModal = () => {
  showModal.value = true;
};

const onValidation = () => {
  window.location.href = props.validateUrl;
};

</script>

<template>
  <div class="bg-faded p-3 mb-3">
    <div v-if="registration.cgu || registration.origin === 'import'" class="text-center">
      <a
        @click.prevent="onValidation"
        class="btn btn-primary btn-md">
        {{ $t('Validate Attendee') }}
      </a>
    </div>

    <div v-else class="text-center">
      <button type="button" class="btn btn-primary btn-md" @click="openModal">
        {{ $t('Validate Attendee') }}
      </button>
    </div>

    <Dialog :open="showModal" @update:open="showModal = $event">
      <DialogScrollContent size="lg">
        <DialogHeader>
          <DialogTitle>
            {{ $t('Terms and Conditions') }}
          </DialogTitle>
        </DialogHeader>

        <div v-html="terms"></div>

        <DialogFooter>
          <button @click.prevent="onValidation" class="btn btn-primary">
            {{ $t('Validate Attendee') }}
          </button>
        </DialogFooter>
      </DialogScrollContent>
    </Dialog>
  </div>
</template>
